import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  year: {
    marginBottom: 14,
    width: 40,
    height: 12,
  },
  month: {
    marginBottom: 18,
    width: 110,
    height: 13,
  },
  price: {
    marginBottom: 26.9,
    width: 82,
    height: 29,
  },
  extraChargesText: {
    marginTop: 18.1,
    marginBottom: 27,
    width: 173,
    height: 13,
  },
  overPaidBillText: {
    marginBottom: 22,
    width: 131,
    height: 13,
  },
  overPaidBillValue: {
    marginBottom: 22,
    marginRight: 5,
    width: 40,
    height: 13,
  },
  extraRoamingCallsText: {
    marginBottom: 22,
    width: 131,
    height: 13,
  },
  extraRoamingCallsValue: {
    marginBottom: 22,
    marginRight: 5,
    width: 40,
    height: 13,
  },
  servicesText: {
    marginBottom: 21,
    marginTop: 5,
    width: 173,
    height: 13,
  },
  serviceIcon: {
    marginRight: 8,
  },
  arrow: {
    marginRight: 2,
  },
  line: {
    width: '100%',
    height: 1,
  },
});
